import { useTranslations } from '@vocab/react';
import { Box, List, Stack, Text } from 'braid-design-system';
import React from 'react';

import { HandIcon } from '../HandIcon';

import translations from './.vocab';

interface Props {
  isHidden?: boolean;
  jobTitle?: string;
}

export const Body = ({ isHidden = true, jobTitle }: Props) => {
  const { t } = useTranslations(translations);
  if (isHidden) {
    return null;
  }
  const inlineText = t('low-salary-feedback-body-inline-text');
  return (
    <Box display="flex" marginTop="medium">
      <Box marginRight="gutter">
        <HandIcon />
      </Box>
      <Box marginRight="gutter">
        <Stack space="small">
          <Text weight="strong">
            {t('low-salary-feedback-body-1', {
              jobTitle: jobTitle ? `${inlineText} ${jobTitle}` : '',
            })}
          </Text>
          <Text>{t('low-salary-feedback-body-2')}</Text>
          <Text>{t('low-salary-feedback-body-3')}:</Text>
          <List space="small">
            <Text>{t('low-salary-feedback-body-4')}</Text>
            <Text>{t('low-salary-feedback-body-5')}</Text>
            <Text>{t('low-salary-feedback-body-6')}</Text>
          </List>
        </Stack>
      </Box>
    </Box>
  );
};
